export default __webpack_public_path__ + "static/media/three.dd9498b0.jpeg";